import EarlyMailRaceTips from "@/components/EarlyMailRaceTips";
import ChevronDownIcon from "@/components/icons/chevron-down-icon";

/**
 * "Show Early Mail" toggle + the race's Early Mail, inside the race tips container
 * (under Late Mail / Race Day tips). Same markup on /todays-tips and /results so the
 * two pages look and behave the same.
 *
 * @param {Object} props
 * @param {Object} props.earlyMail - values returned by `useEarlyMailForRace`
 * @param {boolean} props.isOpen - parent-owned so it stays open across races
 * @param {Function} props.onToggle
 * @param {boolean} [props.limitHeight=true] - cap the open panel (the chat sits under it on /todays-tips)
 * @param {boolean} [props.embedded=false] - no card of its own (it already sits in the race tips container)
 * @param {string} [props.gtmId]
 */
export default function EarlyMailRaceSection({
  earlyMail,
  isOpen,
  onToggle,
  trackName,
  raceNumber,
  date,
  historicalData,
  isResultsPage = false,
  tipMovementSources = null,
  hideTipMovement = false,
  limitHeight = true,
  embedded = false,
  gtmId = "todays-tips_early-mail_button",
}) {
  const hasEarlyMailTips = (earlyMail?.earlyMailTips?.length || 0) > 0;

  return (
    <div className="early-mail-race-section pb-2">
      {/* Same toggle (and styles) as the race-day tip history */}
      {hasEarlyMailTips && (
        <div className="tip-history-button-container flex justify-between items-center">
          <button
            type="button"
            className="text-sm flex ml-auto items-center gap-2"
            onClick={onToggle}
            aria-expanded={isOpen}
            aria-controls="early-mail-race-panel"
            data-gtm-element-id={gtmId}
          >
            <span className="text-xxs uppercase text-[#ABABAB]">
              {isOpen ? "Hide Early Mail" : "Show Early Mail"}
            </span>
            <ChevronDownIcon
              className={`w-3 h-3 text-[#ABABAB] transform transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
            />
          </button>
        </div>
      )}
      {(!hasEarlyMailTips || isOpen) && (
        <div
          id="early-mail-race-panel"
          // Dashed divider, as above the race-day tip history
          className={`${limitHeight ? "max-h-[45vh] overflow-y-auto" : ""} ${hasEarlyMailTips ? "mt-2 border-t border-dashed border-gray-400" : ""}`}
        >
          <EarlyMailRaceTips
            {...earlyMail}
            trackName={trackName}
            raceNumber={raceNumber}
            date={date}
            historicalData={historicalData}
            isResultsPage={isResultsPage}
            tipMovementSources={tipMovementSources}
            hideTipMovement={hideTipMovement}
            embedded={embedded}
          />
        </div>
      )}
    </div>
  );
}
